/**
 * lightningGlyph.ts — مسار رمز الصاعقة، مصدراً واحداً لطبقتَي البرق.
 *
 * تستعمله طبقتان تختلفان في كل شيء عدا الشكل: `LightningLayer` (برق **متوقَّع** من
 * النموذج، عناصر DOM بصورة خلفية SVG) و`GlmLightningLayer` (برق **مرصود** من قمر
 * GOES‏، كانفاس واحد). ولو تكرّر المسار فيهما لانحرف أحدهما عند أوّل تعديل، فيرى
 * المستخدم صاعقتين مختلفتين على خريطة واحدة بلا سبب يفهمه.
 */

/** مسار الصاعقة في مربّع 24×24، الأصل أعلى-يسار. */
export const BOLT_PATH_D = 'M13 2 4 14h6l-1 8 9-12h-6l1-8Z';

/** ضلع المربّع الذي رُسم فيه المسار — للتحجيم. */
export const BOLT_UNITS = 24;
